import { i18n } from '@lingui/core';

export const getTranslations = () => ({
    TESTS: i18n._('navigation.tests'),
    ASSESSMENTS: i18n._('navigation.assessments'),
    SKILL_QUESTS: i18n._('navigation.skillQuests'),
    REVISE_5: i18n._('navigation.revise5'),
    CHALLENGES: i18n._('navigation.challenges'),
    ACTIVITIES: i18n._('navigation.activities'),
    NEW_COURSES: i18n._('navigation.newCourses'),
    LEARN: i18n._('navigation.learn'),
    REVISE: i18n._('navigation.revise'),
    ASSESS: i18n._('navigation.assess')
});
